export default __webpack_public_path__ + "static/uzh-0da51121ccbdc5f793005cbf28c881cf.png";